import { Result } from "antd"

const AccessDenied = () => {

    return <Result
        status="403"
        title={<p className="text-2xl font-semibold text-subTextColor mb-0">Access Denied</p>}
        subTitle={<p className="text-base font-normal text-paraColor mb-0">Please contact administrator</p>}
    />

}
export default AccessDenied;